import React from "react";
import { Link } from "react-router-dom";

const EmptyCampaigns = () => {

    return (

        <div className="empty-state">

            <h2>No Campaigns Found</h2>

            <p>

                Create your first marketing campaign.

            </p>

            <Link
                to="/admin/marketing/create"
                className="create-btn"
            >

                Create Campaign

            </Link>

        </div>

    );

};

export default EmptyCampaigns;